import { Injectable } from "@angular/core";

import { BehaviorSubject, Observable } from "rxjs";

import { ProductLoaded } from "@hermes/states/grid-filters-state";

@Injectable()
export class ProductInViewportService {
    public productsLoadedInViewPort$: Observable<ProductLoaded[]>;

    private productsLoadedInViewPortEvent: BehaviorSubject<ProductLoaded[]> =
        new BehaviorSubject([] as ProductLoaded[]);
    private map: Map<
        string,
        { productLoaded?: ProductLoaded; isAnalyticsPrint: boolean }
    > = new Map();

    constructor() {
        this.productsLoadedInViewPort$ =
            this.productsLoadedInViewPortEvent.asObservable();
    }

    public addOrUpdateProductLoadByItemId(
        key: string,
        productLoaded?: ProductLoaded,
    ): void {
        const currentMapValue = this.map.get(key);
        this.map.set(key, {
            productLoaded,
            isAnalyticsPrint:
                currentMapValue === undefined
                    ? false
                    : currentMapValue.isAnalyticsPrint,
        });
        this.productsLoadedInViewPortEvent.next(
            this.getProductsLoadedInViewPort(),
        );
    }

    public productsLoadInViewPortAnalyticPrint(): void {
        this.map.forEach((value) => {
            if (value.productLoaded && !value.isAnalyticsPrint) {
                value.isAnalyticsPrint = true;
            }
        });
    }

    public clearProductsLoadInViewPort(): void {
        this.map.clear();
        this.productsLoadedInViewPortEvent.next([]);
    }

    private getProductsLoadedInViewPort(): ProductLoaded[] {
        return [...this.map.values()]
            .filter((data) => data.productLoaded && !data.isAnalyticsPrint)
            .map((data) => data.productLoaded as ProductLoaded);
    }
}
